import { PUBLIC_REQUEST_KEY, API_PATH, TOKEN_PAYLOAD_KEY, AUTH_TOKEN_KEY } from "../../constants/common.constant"
import fetch_ from "../../interceptors/FetchInterceptor"
import axios from "axios"
import { GetLocalStorage } from "../../utils/common"
import { API_BASE_URL } from "../../configs/AppConfig"

const {
    GET_ESSAY,
    USERS_LIST,
    USERS_COUNT,
    BUSINESS_USERS_COUNT,
    USERS_REGISTER,
    BUSINESS_USER_REGISTER,
    BUSINESS_USERS_EDIT,
    BUSINESS_USERS_LIST_FILTER,
    USERS_UPDATE,
    USERS_DETAIL,
    USERS_DELETE,
    USERS_FORM_FIELDS,
    USERS_ADMIN_RESET_PASSWORD,
    ADMIN_USERS_LIST,
    ADMIN_USERS_CREATE,
    ADMIN_USERS_STATUS,
    BUSINESS_USERS_LIST,
    BUSINESS_USER_RESET_PASSWORD,
    ORDERS_LIST, ORDERS_COUNT, ORDERS_DATE_RANGE_SEARCH, ORDERS_EXPORT_EXCEL, ORDERS_SUMMARY,
    ORDERS_STRIPE_INVOICE_FAILURE_REASON, ORDERS_STRIPE_PAYMENT_INTENT_FAILURE_REASON
} = API_PATH;

export const UserService_ = {
    getEssay: (filter) => {
        return fetch_({
            url: GET_ESSAY,
            method: 'POST',
            data: filter,
            headers: {
                [PUBLIC_REQUEST_KEY]: true
            },
        })
    },

    getUsers: (filter) => {
        return fetch_({
            url: USERS_LIST,
            method: 'GET',
            params: filter
        })
    },
    getBusinessUsersWithFilter: (filter) => {
        return fetch_({
            url: BUSINESS_USERS_LIST_FILTER,
            method: 'GET',
            params: filter
        })
    },

    getBusinessUsers: () => {
        return fetch_({
            url: BUSINESS_USERS_LIST,
            method: 'GET',
        })
    },

    getFormfields: (filter) => {
        return fetch_({
            url: USERS_FORM_FIELDS,
            method: 'GET',
            params: filter
        })
    },
    countUsers: (filter) => {
        return fetch_({
            url: USERS_COUNT,
            method: 'GET',
            params: filter
        })
    },
    countBusinessUsers: (filter) => {
        return fetch_({
            url: BUSINESS_USERS_COUNT,
            method: 'GET',
            params: filter
        })
    },
    getUser: userId => {
        return fetch_({
            url: USERS_DETAIL(userId),
            method: 'GET',
        })
    },
    addUser: user => {
        return fetch_({
            url: USERS_REGISTER,
            method: 'POST',
            data: user
        })
    },

    addBusinessUser: user => {
        return fetch_({
            url: BUSINESS_USER_REGISTER,
            method: 'POST',
            data: user
        })
    },
    updateUser: (userId, user) => {
        return fetch_({
            url: USERS_UPDATE(userId),
            method: 'PUT',
            data: user
        })
    },
    updateBusinessUser: (userId, user) => {
        return fetch_({
            url: BUSINESS_USERS_EDIT(userId),
            method: 'PUT',
            data: user
        })
    },
    resetBusinessUserPassword: (email, newPassword) => {
        return fetch_({
            url: BUSINESS_USER_RESET_PASSWORD,
            method: 'PUT',
            data: {
                email,
                newPassword
            }
        })
    },
    deleteUser: (userId) => {
        return fetch_({
            url: USERS_DELETE(userId),
            method: 'DELETE'
        })
    },
    adminResetUserPassword: (userId, newPassword) => {
        return fetch_({
            url: USERS_ADMIN_RESET_PASSWORD(userId),
            method: 'PUT',
            data: { newPassword }
        })
    },
    getAdminUsers: () => {
        return fetch_({
            url: ADMIN_USERS_LIST,
            method: 'GET'
        })
    },
    createAdminUser: (adminUser) => {
        return fetch_({
            url: ADMIN_USERS_CREATE,
            method: 'POST',
            data: adminUser
        })
    },
    updateAdminUserStatus: (userId, status) => {
        return fetch_({
            url: ADMIN_USERS_STATUS(userId),
            method: 'PUT',
            data: { status }
        })
    },
    getOrders: (filter) => {
        // Serialize the where clause if it exists
        const params = { ...filter };
        if (params.where && typeof params.where === 'object') {
            params.where = JSON.stringify(params.where);
        }
        return fetch_({
            url: ORDERS_LIST,
            method: 'GET',
            params: params
        })
    },
    countOrders: (filter) => {
        // Serialize the where clause if it exists
        const params = { ...filter };
        if (params.where && typeof params.where === 'object') {
            params.where = JSON.stringify(params.where);
        }
        return fetch_({
            url: ORDERS_COUNT,
            method: 'GET',
            params: params
        })
    },
    getOrdersSummary: (params) => {
        return fetch_({
            url: ORDERS_SUMMARY,
            method: 'GET',
            params: params
        })
    },
    getStripeInvoiceFailureReason: (invoiceId) => {
        return fetch_({
            url: ORDERS_STRIPE_INVOICE_FAILURE_REASON(invoiceId),
            method: 'GET'
        })
    },
    getStripePaymentIntentFailureReason: (paymentIntentId) => {
        return fetch_({
            url: ORDERS_STRIPE_PAYMENT_INTENT_FAILURE_REASON(paymentIntentId),
            method: 'GET'
        })
    },
    exportOrdersToExcel: (filter) => {
        const jwtToken = GetLocalStorage(AUTH_TOKEN_KEY);
        // Export endpoint expects simple query parameters, not a where clause
        const params = { ...filter };

        // Use the export endpoint with blob response for Excel export
        return axios.get(`${API_BASE_URL}api/v1${ORDERS_EXPORT_EXCEL}`, {
            params: params,
            responseType: 'blob',
            headers: {
                [TOKEN_PAYLOAD_KEY]: `Bearer ${jwtToken}`
            },
            timeout: 120000
        }).then(response => response.data).catch(error => {
            // Fallback: if export endpoint fails, show error to user
            console.error("Export endpoint error:", error);
            throw new Error("Failed to export Excel file");
        })
    },
    getAdmins: () => {
        return fetch_({
            url: '/scholarships/scholarship-count',
            method: 'POST',
            data: {
                queries: []
            }
        })
    }
}
